module.exports = __webpack_public_path__ + "img/img-scholarshipprogram1@2x.4bfba84e.jpg";